export const coordenadaState = {
    ubicacion_ie: { "lat": 0, "lng": 0 } ,
    ubicacion_user: { "lat": 0, "lng": 0 }
}